/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import { ValuePropsModule, getModuleLayoutConfig } from '@coursera-web/cds-labs';
import type { ValuePropItem } from '@coursera-web/cds-labs';

import type { PromoTemplateValuePropsFragment } from 'bundles/promo-template/__generated__/contentfulTypes';

type Props = {
  content: PromoTemplateValuePropsFragment & {
    preloadImage?: boolean;
    lazyLoadImage?: boolean;
    removeTopPadding?: boolean;
  };
};

const ValuePropsModuleRenderer = ({ content }: Props) => {
  const convertedValueProps: ValuePropItem[] =
    content.valuePropCardsCollection?.items.filter(Boolean).map((item) => {
      return {
        id: item.sys.id,
        description: item.description,
        headline: item.headline,
        icon: {
          url: item.icon?.url,
          description: item.icon?.description,
          width: item.icon?.width,
          height: item.icon?.height,
        },
        ctaText: item.ctaText,
        ctaTarget: item.ctaTarget,
        ctaVariant: item.ctaVariant,
      };
    }) ?? [];
  const layoutConfig = getModuleLayoutConfig(content);
  return (
    <ValuePropsModule
      headline={content.headline}
      description={content.description}
      valueProps={convertedValueProps}
      {...layoutConfig}
    />
  );
};

export default ValuePropsModuleRenderer;
